module.exports = __webpack_public_path__ + "static/img/rppghealthapp7.8e9e74c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rppghealth/rppghealthapp7.png
// module id = tN8P
// module chunks = 4